export const SITE_URL = process.env.REACT_APP_SITE_URL;
export const SITE_NAME = 'Bourbon';
export const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;
export const DEFAULT_DESCRIPTION =
  "Bourbon, lo réseau social péi : alertes en temps réel, événements, bons plans et vie de quartier dans les 24 communes de La Réunion.";

export const ORGANIZATION_LD = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: SITE_NAME,
  url: SITE_URL,
  logo: `${SITE_URL}/logo512.png`,
  description: DEFAULT_DESCRIPTION,
  areaServed: { '@type': 'AdministrativeArea', name: 'La Réunion' },
  contactPoint: { '@type': 'ContactPoint', email: 'contact@bourbon-reunion.re', contactType: 'customer support', availableLanguage: ['fr'] },
};

export const WEBSITE_LD = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: SITE_NAME,
  alternateName: 'Bourbon – Lo réseau social péi',
  url: SITE_URL,
  inLanguage: 'fr',
  publisher: { '@type': 'Organization', name: SITE_NAME, url: SITE_URL },
  potentialAction: {
    '@type': 'SearchAction',
    target: { '@type': 'EntryPoint', urlTemplate: `${SITE_URL}/search?q={search_term_string}` },
    'query-input': 'required name=search_term_string',
  },
};

export const WEBAPP_LD = {
  '@context': 'https://schema.org',
  '@type': 'WebApplication',
  name: SITE_NAME,
  url: SITE_URL,
  applicationCategory: 'SocialNetworkingApplication',
  operatingSystem: 'Web, Android, iOS',
  inLanguage: 'fr',
  offers: { '@type': 'Offer', price: '0', priceCurrency: 'EUR' },
  description: DEFAULT_DESCRIPTION,
};

// Route-level metadata. `noindex: true` marks private pages (auth, dashboards, admin...).
export const ROUTE_META = {
  '/': {
    title: 'Bourbon – Lo réseau social péi de La Réunion',
    description: DEFAULT_DESCRIPTION,
    jsonLd: [ORGANIZATION_LD, WEBSITE_LD, WEBAPP_LD],
  },
  '/calendar': {
    title: 'Agenda des événements à La Réunion – Bourbon',
    description: "Concerts, marchés, fêtes de quartier, kabar : l'agenda des événements péi par commune, mis à jour chaque jour par la communauté Bourbon.",
  },
  '/map': {
    title: 'Carte interactive de La Réunion – Alertes et actus par commune – Bourbon',
    description: 'Visualisez sur la carte les alertes, événements et bons plans publiés dans les 24 communes de La Réunion.',
  },
  '/search': {
    title: 'Rechercher une actu, un événement ou un commerce péi – Bourbon',
    description: 'Recherchez des publications, des événements, des commerces et des habitants dans votre commune de La Réunion.',
  },
  '/auth': { title: 'Connexion / Inscription – Bourbon', noindex: true },
  '/feed': { title: "Fil d'actualités – Bourbon", noindex: true },
  '/create': { title: 'Nouvelle publication – Bourbon', noindex: true },
  '/profile': { title: 'Mon profil – Bourbon', noindex: true },
  '/settings': { title: 'Paramètres – Bourbon', noindex: true },
  '/settings/stats': { title: 'Statistiques Premium – Bourbon', noindex: true },
  '/messages': { title: 'Messagerie – Bourbon', noindex: true },
  '/notifications': { title: 'Notifications – Bourbon', noindex: true },
  '/chat': { title: 'Chat de quartier – Bourbon', noindex: true },
  '/commerce-settings': { title: 'Espace commerce – Bourbon', noindex: true },
  '/admin': { title: 'Administration – Bourbon', noindex: true },
  '/boost/success': { title: 'Boost confirmé – Bourbon', noindex: true },
  '/boost/cancel': { title: 'Boost annulé – Bourbon', noindex: true },
  '/subscription': { title: 'Abonnement Premium – Bourbon', noindex: true },
  '/subscription/success': { title: 'Abonnement confirmé – Bourbon', noindex: true },
  '/subscription/cancel': { title: 'Abonnement annulé – Bourbon', noindex: true },
};

const PRIVATE_PREFIXES = ['/messages/', '/chat/', '/boost/', '/subscription/'];

export const getRouteMeta = (pathname) => {
  if (ROUTE_META[pathname]) return ROUTE_META[pathname];
  if (PRIVATE_PREFIXES.some((p) => pathname.startsWith(p))) return { title: 'Bourbon', noindex: true };
  // Dynamic public pages set their own <SEO> once data is loaded
  if (pathname.startsWith('/post/')) return { title: 'Publication – Bourbon', description: DEFAULT_DESCRIPTION };
  if (pathname.startsWith('/profile/')) return { title: 'Profil – Bourbon', description: DEFAULT_DESCRIPTION };
  if (pathname.startsWith('/commune/')) return { title: 'Commune – Bourbon', description: DEFAULT_DESCRIPTION };
  return { title: 'Page introuvable – Bourbon', noindex: true };
};

export const truncate = (text = '', max = 155) => {
  const clean = String(text).replace(/\s+/g, ' ').trim();
  return clean.length > max ? `${clean.slice(0, max - 1).trimEnd()}…` : clean;
};
